import { defineStore } from 'pinia'

export const useSidebarStore = defineStore('sidebar-state', () => {
   const open = ref<boolean>(false)
   const openGroups = ref<Record<string, boolean>>({})

   const toggleGroup = (key: string) => {
      openGroups.value[key] = !openGroups.value[key]
   }

   const openGroup = (key: string) => {
      openGroups.value[key] = true
   }

   return { open, openGroups, toggleGroup, openGroup }
})
